import React from 'react';
import {View, Text, Button, TouchableOpacity, Dimensions} from 'react-native';
import {Icon} from '../icons';

export const Header = props => {
  return (
    <View style={{height: 100}}>
      {Dimensions.get('screen').width > 720 ? (
        <View
          style={{
            width: '60%',
            alignSelf: 'flex-end',
            height: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingEnd: 20,
          }}>
          <TouchableOpacity onPress={() => props.callback(1)}>
            <Text style={{color: '#44A9C9', fontSize: 22, fontWeight: '600'}}>
              About
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => props.callback(2)}>
            <Text style={{color: '#44A9C9', fontSize: 22, fontWeight: '600'}}>
              Projects
            </Text>
          </TouchableOpacity>
          <Text style={{color: '#44A9C9', fontSize: 22, fontWeight: '600'}}>
            Work
          </Text>
          <Text style={{color: '#44A9C9', fontSize: 22, fontWeight: '600'}}>
            Articles
          </Text>
          <TouchableOpacity style={{height: '50%', width: 200}}>
            <View
              style={{
                height: '50%',
                backgroundColor: '#44A9C9',
                borderRadius: 10,
                alignItems: 'center',
                justifyContent: 'center',
                width: 200,
                alignSelf: 'center',
                flex: 1,
              }}>
              <Text
                style={{
                  alignSelf: 'center',
                  color: 'white',
                  fontWeight: '600',
                }}>
                Hire Me
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      ) : (
        <View
          style={{
            justifyContent: 'space-between',
            flexDirection: 'row',
            flex: 1,
            alignItems: 'center',
            width: '90%',
            alignSelf: 'center',
          }}>
          <Icon name="menu" size={30} color="black" />
          <TouchableOpacity style={{height: 40, width: 70}}>
            <View
              style={{
                height: 40,
                backgroundColor: '#44A9C9',
                borderRadius: 10,
                alignItems: 'center',
                justifyContent: 'center',
                width: 70,
                alignSelf: 'center',
                flex: 1,
              }}>
              <Text
                style={{
                  alignSelf: 'center',
                  color: 'white',
                  fontWeight: '600',
                }}>
                Hire Me
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};
